import { useMemo } from "react";
import { useRouteChecks } from "./useRouteChecks";

export const useFooterVisibility = () => {
  const { inFooterCheckRouter } = useRouteChecks();
  return useMemo(
    () => !Object.values(inFooterCheckRouter).some(Boolean),
    [inFooterCheckRouter]
  );
};
